import "core-js/modules/es6.object.freeze";
import { colors, colorsRefresh } from '../colors';
export var footer = Object.freeze({
  light: {
    backgroundColor: colors.white
  },
  dark: {
    backgroundColor: colors.dark
  }
});
export var footerRefresh = Object.freeze({
  light: {
    backgroundColor: colorsRefresh.white
  },
  dark: {
    backgroundColor: colorsRefresh.dark
  }
});